/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Comparison_LowestInputs */

const id_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terendah`)
};

const ms_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terendah`)
};

const da_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laveste`)
};

const de_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niedrigster`)
};

const en_us2_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lowest`)
};

const es_es2_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mínimo`)
};

const es_mx2_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mínimo`)
};

const fil_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinakamababa`)
};

const fr_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus bas`)
};

const it_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimo`)
};

const hu_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legalacsonyabb`)
};

const nl_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laagste`)
};

const no_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laveste`)
};

const pl_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najniższa`)
};

const pt_br2_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lowest`)
};

const pt_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mínimo`)
};

const ro_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cel mai mic`)
};

const fi_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alin`)
};

const sv_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lägsta`)
};

const vi_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thấp nhất`)
};

const tr_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En Düşük`)
};

const cs_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejnižší`)
};

const bg_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Най-ниска`)
};

const ru_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Самая низкая`)
};

const uk_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найнижча`)
};

const ar_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأدنى`)
};

const hi_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`न्यूनतम`)
};

const th_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต่ำสุด`)
};

const ja_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最安値`)
};

const zh_cn2_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lowest`)
};

const zh_hant1_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lowest`)
};

const ko_components_comparison_lowest = /** @type {(inputs: Components_Comparison_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lowest`)
};

/**
* | output |
* | --- |
* | "Lowest" |
*
* @param {Components_Comparison_LowestInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_comparison_lowest = /** @type {((inputs?: Components_Comparison_LowestInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Comparison_LowestInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_comparison_lowest(inputs)
	if (locale === "ms") return ms_components_comparison_lowest(inputs)
	if (locale === "da") return da_components_comparison_lowest(inputs)
	if (locale === "de") return de_components_comparison_lowest(inputs)
	if (locale === "en-US") return en_us2_components_comparison_lowest(inputs)
	if (locale === "es-ES") return es_es2_components_comparison_lowest(inputs)
	if (locale === "es-MX") return es_mx2_components_comparison_lowest(inputs)
	if (locale === "fil") return fil_components_comparison_lowest(inputs)
	if (locale === "fr") return fr_components_comparison_lowest(inputs)
	if (locale === "it") return it_components_comparison_lowest(inputs)
	if (locale === "hu") return hu_components_comparison_lowest(inputs)
	if (locale === "nl") return nl_components_comparison_lowest(inputs)
	if (locale === "no") return no_components_comparison_lowest(inputs)
	if (locale === "pl") return pl_components_comparison_lowest(inputs)
	if (locale === "pt-BR") return pt_br2_components_comparison_lowest(inputs)
	if (locale === "pt") return pt_components_comparison_lowest(inputs)
	if (locale === "ro") return ro_components_comparison_lowest(inputs)
	if (locale === "fi") return fi_components_comparison_lowest(inputs)
	if (locale === "sv") return sv_components_comparison_lowest(inputs)
	if (locale === "vi") return vi_components_comparison_lowest(inputs)
	if (locale === "tr") return tr_components_comparison_lowest(inputs)
	if (locale === "cs") return cs_components_comparison_lowest(inputs)
	if (locale === "bg") return bg_components_comparison_lowest(inputs)
	if (locale === "ru") return ru_components_comparison_lowest(inputs)
	if (locale === "uk") return uk_components_comparison_lowest(inputs)
	if (locale === "ar") return ar_components_comparison_lowest(inputs)
	if (locale === "hi") return hi_components_comparison_lowest(inputs)
	if (locale === "th") return th_components_comparison_lowest(inputs)
	if (locale === "ja") return ja_components_comparison_lowest(inputs)
	if (locale === "zh-CN") return zh_cn2_components_comparison_lowest(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_comparison_lowest(inputs)
	return ko_components_comparison_lowest(inputs)
});
export { components_comparison_lowest as "components.comparison.lowest" }